import { combineReducers } from "redux";
import { createItemReducer, createItemReducerParams } from "@mnjsplatform/data/lib/reducers/dataItemReducer";

export function subEducationReducer() {
    return combineReducers({
        EmployeesEducation_ListSubForPO: createItemReducer("SubEducation", "Education.ListSubForNewPO", false),
        EmployeesEducation_ListSubForPOParams: createItemReducerParams("SubEducation", "Education.ListSubForNewPO")
    });
}